<template>
  <a-modal
    ref="createModal"
    title="工单排产"
    :width="850"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="20">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="车间" prop="workCode">
            <global-select
              :disabled="true"
              :value.sync="form.workCode"
              selectType="select"
              requestApi="/mes/mesDiscreteJobs/workCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ organizationCode: baseData.desOrganizationCode }"
              @change="onChangeWorkCode"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="工作中心" prop="workCenterCode">
            <global-select
              :value.sync="form.workCenterCode"
              selectType="selectAssembleSearch"
              searchParam="centerName"
              :selectData="defaultWorkList"
              assembleLabel
              focusGet
              requestApi="/bom/workCenter/list"
              :selectItem="{ value: 'centerCode', label: 'centerName' }"
              :setParams="{ workshopCode: form.workCode }"
              @change="getTeam('workCenter')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划开始时间" prop="scheduledStartDate">
            <a-date-picker
              v-model="form.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('08:00:00', 'HH:mm:ss') }"
              allowClear
              @change="onChangeStartDate"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划完成时间" prop="scheduledCompletionDate">
            <a-date-picker
              v-model="form.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('23:59:59', 'HH:mm:ss') }"
              allowClear
              @change="getTeam"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="班组" prop="teamGroupCode">
            <global-select
              ref="teamGroupCodeRef"
              :value.sync="form.teamGroupCode"
              focusGet
              :selectData="defaultTeamList"
              assembleLabel
              selectType="selectAssembleSearch"
              searchParam="teamName"
              requestApi="/bom/team/list"
              :selectItem="{ value: 'teamCode', label: 'teamName' }"
              :setParams="{ workshopCode: form.workCode, centerCode: form.workCenterCode }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="排产备注" prop="productionSchedulingRemarks">
            <a-input v-model="form.productionSchedulingRemarks" allowClear :maxLength="100" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-space slot="footer">
      <a-button @click="onClose">取消</a-button>
      <a-button @click="onConfirmSchedule" :loading="confirmLoading" type="primary">确认排产</a-button>
      <a-button @click="onConfirmPublish" :loading="confirmLoading" type="primary">确认并发布</a-button>
    </a-space>
  </a-modal>
</template>

<script>
import {
  apiPublishScheduleMesDiscreteJobsCc,
  apiConfirmScheduleMesDiscreteJobsCc, apiGetBomTeamScheduleCcList, apiGetBomTeam
} from '@/api/mes/workOrderManage/ticketsManageCc'
import { mapState } from 'vuex'
import pick from 'lodash/pick'
import deepClone from 'lodash/cloneDeep'
export default {
  name: 'ScheduleModal',
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      confirmLoading: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      },
      // 表单参数
      form: {},
      baseData: {},
      // 表单校验
      rules: {
        workCode: [
          { required: true, message: '请选择车间', trigger: 'change' }
        ],
        // workCenterCode: [
        //   { required: true, message: '请选择工作中心', trigger: 'change' }
        // ],
        // teamGroupCode: [
        //   { required: true, message: '请选择班组', trigger: 'change' }
        // ],
        scheduledStartDate: [
          { required: true, message: '请选择计划开始时间', trigger: 'change' }
        ],
        scheduledCompletionDate: [
          { required: true, message: '请选择计划完成时间', trigger: 'change' }
        ]
      },
      defaultTeamList: [],
      defaultWorkList: []
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.form = this.getInitData();
  },
  methods: {
    onChangeDate() {
      this.form.teamGroupCode = undefined;
    },
    show (selectList) {
      this.visible = true
      this.confirmLoading = false
      const itemData = selectList[0] || {}
      this.baseData = { ...itemData };
      this.selectList = selectList;
      this.form.workCode = itemData.workCode;
      if(this.selectList.length === 1) {
        const formData = deepClone(pick(itemData, [
          'workCode',
          'workCenterCode',
          'teamGroupCode',
          'scheduledStartDate',
          'scheduledCompletionDate',
          'productionSchedulingRemarks'
        ]))
        for(const field in formData) {
          this.form[field] = formData[field];
        }
        this.defaultTeamList = [{ teamName: itemData.teamGroupName, teamCode: itemData.teamGroupCode }]
        this.defaultWorkList = [{ centerCode: itemData.workCenterCode, centerName: itemData.workCenterName }]
      }
    },
    // 关闭模态框
    onClose () {
      this.$refs.ruleForm.resetFields();
      this.visible = false
      this.reset()
    },
    getParams() {
      let params = null;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const ids = this.selectList.map(item => item.id);
          params = {
            ids,
            ...this.form,
            scheduledStartDate: this.$moment(this.form.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss'),
            scheduledCompletionDate: this.$moment(this.form.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      })
      return params
    },
    onConfirmPublish () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true;
      this.$emit('update:mainBtnLoading', true);
      apiPublishScheduleMesDiscreteJobsCc(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('successCall')
          this.reset()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.confirmLoading = false
        this.$emit('update:mainBtnLoading', false);
      })
    },
    onConfirmSchedule () {
      const params = this.getParams();
      if(!params) {
        return;
      }
      this.confirmLoading = true
      this.$emit('update:mainBtnLoading', true);
      apiConfirmScheduleMesDiscreteJobsCc(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('successCall')
          // 刷新表单
          this.reset()
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$emit('update:mainBtnLoading', false);
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.form = this.getInitData();
    },
    getInitData() {
      return {
        workCode: undefined,
        workCenterCode: undefined,
        teamGroupCode: undefined,
        scheduledStartDate: undefined,
        scheduledCompletionDate: undefined,
        productionSchedulingRemarks: undefined
      }
    },
    onChangeWorkCode() {
      this.form.workCenterCode = undefined
      this.form.teamGroupCode = undefined
    },
    getCustomKeyFunc(item, index) {
      return index + item.centerCode
    },
    onChangeStartDate(value) {
      if(value) {
        this.form.scheduledCompletionDate = this.$moment(value).endOf('day');
      }
    },
    // 仅通过工作中心获取班组，该接口去重
    getTeamByWorkCenter() {
      const params = {
        centerCode: this.form.workCenterCode,
        workshopCode: this.form.workCode
      }
      apiGetBomTeam(params).then(res => {
        if(res.code === 200) {
          const { rows = [] } = res;
          const teamCode = rows[0]?.teamCode;
          if(teamCode) {
            this.form.teamGroupCode = teamCode
            this.$refs.teamGroupCodeRef.selectList = [ rows[0] ]
          }
        }
      })
    },
    getTeam(from) {
      const startTime = this.form.scheduledStartDate && this.$moment(this.form.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss');
      const endTime = this.form.scheduledCompletionDate && this.$moment(this.form.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss');
      const params = {
        startTime,
        endTime,
        workshopCode: this.form.workCode,
        centerCode: this.form.workCenterCode,
        enable: 1
      }
      if(from === 'workCenter') {
        this.form.teamGroupCode = '';
      }
      if(startTime && endTime && params.workshopCode && params.centerCode) {
        apiGetBomTeamScheduleCcList(params).then(res => {
          if(res.code === 200) {
            const { rows = [] } = res;
            const teamCode = rows[0]?.teamCode;
            if(teamCode) {
              this.form.teamGroupCode = teamCode
              this.$refs.teamGroupCodeRef.selectList = [ rows[0] ]
            }else {
              if(from === 'workCenter' && this.form.workCenterCode) {
                this.getTeamByWorkCenter();
              }
            }
          }
        })
      }
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
/deep/.ant-select{
  width: 180px;
}
input{
  width: 180px;
}
/deep/.ant-input-number{
  width: 180px;
}
/deep/.ant-calendar-picker{
  min-width: 180px !important;
}
/deep/.ant-form-item-control{
  min-width: 180px !important;
}
</style>
